import React, { Component } from 'react'
import { login, resetPassword, getUserInfo } from '../helpers/auth'
import { Link } from 'react-router-dom'
import { connect } from 'react-redux'
import { signIn } from '../reducers/user'
import { PrimaryButton } from './Button'

function setErrorMsg(error) {
  return {
    loginMessage: error
  }
}

class Login extends Component {
  state = { loginMessage: null }

  handleSubmit = (e) => {
    e.preventDefault()
    login(this.email.value, this.pw.value)
      .then((user) => {
        console.log(user);
        return getUserInfo(user.uid)
      })
      .then(user => {
        // Redux event
        this.props.signIn(user)
      })
      .catch((error) => {
          this.setState(setErrorMsg('Invalid username/password.'))
        })
  }

  resetPassword = () => {
    resetPassword(this.email.value)
      .then(() => this.setState(setErrorMsg(`Password reset email sent to ${this.email.value}.`)))
      .catch((error) => this.setState(setErrorMsg(`Email address not found.`)))
  }

  render () {
    return (
      <div className=" br2 pv3 ph4 bg-white shadow-custom center mw6 mv6-ns">
        <h1 className="fw2 tc mb4">Sign in to Polaris</h1>
        {
          this.state.loginMessage &&
          <div className="bg-washed-red pa3 f6 mb3 br2" >
            {this.state.loginMessage} <a href="#_" onClick={this.resetPassword} className="link black underline">Forgot Password?</a>
          </div>
        }
        <form onSubmit={this.handleSubmit}>
          <div className="form-group">
            <input className="form-control w-100 mb3 border-box input-reset ba b--black-20 pa3 db br2" ref={(email) => this.email = email} placeholder="Email"/>
          </div>
          <div className="form-group">
            <input type="password" className="form-control w-100 mb3 border-box input-reset ba b--black-20 pa3 db br2" placeholder="Password" ref={(pw) => this.pw = pw} />
          </div>

          <PrimaryButton type="submit" className="btn btn-primary w-100 pv3">Sign in</PrimaryButton>
        </form>
        <p className="tc">Don't have an account? <Link className="link blue" to="/register">Sign up</Link></p>
      </div>
    )
  }
}

export default connect(
  (state) => ({
    currentUser: state.user.currentUser,
  }),
  {signIn}
)(Login)



// WEBPACK FOOTER //
// ./src/components/Login.js